import type { RozetTonu } from "@koclukpanel/ui";
import type { SiparisDurumu, SiparisIptalNedeni } from "./magaza-tipleri";

/**
 * PANEL MAĞAZA ETİKETLERİ — F-GAM-16/17, dalga 2 / 7a.
 *
 * `magaza-tipleri.ts` içindeki `SIPARIS_IPTAL_NEDENI_ETIKETI` ÖĞRENCİ diliyle yazılı ("Sen iptal ettin", "Velin
 * onaylamadı"); personel ekranında bu cümleler yanlış kişiye konuşur. Panel için üçüncü kişi dili burada.
 */

export const PANEL_IPTAL_NEDENI_ETIKETI: Record<SiparisIptalNedeni, string> = {
  STUDENT: "Öğrenci iptal etti",
  PARENT_REJECTED: "Veli onaylamadı",
  PARENT_TIMEOUT: "Onay süresi doldu",
  ADMIN: "Kurum iptal etti",
  UNDELIVERABLE: "Teslim edilemedi",
};

/** Durum rozetinin tonu: renk tek başına anlam taşımaz, rozet metni her zaman yazılıdır. */
export const SIPARIS_DURUMU_TONU: Record<SiparisDurumu, RozetTonu> = {
  AWAITING_PARENT: "uyari",
  AWAITING_ADDRESS: "uyari",
  PREPARING: "bilgi",
  SHIPPED: "bilgi",
  DELIVERED: "onay",
  CANCELLED: "notr",
};

/** Kısa, sayı biçimi tarayıcı yerel ayarına bağlı olmayan TL yazımı. */
export function tlYazisi(tutar: number | string): string {
  // Sözleşme TL'yi "1234.50" metni olarak döndürür; gösterimde gereksiz sıfırlar atılır.
  const n = typeof tutar === "string" ? Number(tutar) : tutar;
  return `${String(Math.round(n * 100) / 100).replace(".", ",")} TL`;
}
